import { Component, OnInit } from '@angular/core';
import { DialogService } from 'src/app/services/dialogService/dialog-service';
import { ProductsService } from 'src/app/services/productsService/products.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.less']
})
export class SubscriptionsComponent implements OnInit {
  activeProducts;
  availableProducts;
  env = environment;
  constructor(private productsService: ProductsService, private dialogService: DialogService) { }

  ngOnInit(): void {
    this.activeProducts = new Array();
    this.availableProducts = new Array();
    this.getData();
  }

  // Get Products Data
  getData() {
    this.productsService.getProducts().then((resp: any) => {
      resp.data.products.map(obj => {
        obj.definition = this.productsService.getDefinitions(obj.rendition);
      });
      this.activeProducts = resp.data.products.filter(obj => obj.isSubscribed || obj.cancelled);
      this.availableProducts = resp.data.products.filter(obj => !obj.isSubscribed && !obj.cancelled);
    });
  }

  // Subscribe into a product
  subscribe(product) {
    this.productsService.subscribeSingleProduct(product).then(resp => {
      this.ngOnInit();
    });
  }

  // Cancel Subscription
  cancelSubscription(product) {
    this.dialogService.openConfirmDialog({
      title: "gen_cancel_subscription",
      message: "info_cancel_subscription_msg",
      confirm: "gen_ok",
      cancel: "gen_cancel"
    }).subscribe(result => {
      if (result) {
        this.productsService.cancelProduct({ productId: product.subscriptionId }).then((resp: any) => {
          this.ngOnInit();
        });
      }
    });
  }
}